module.exports = __webpack_public_path__ + "static/media/Export.cd106355.svg";